export const determineIfIsImage = (toBeDetermined = {}) => {
  return toBeDetermined.hasOwnProperty('portrait');
};
